module.controller('sampleScheduleCtrl', [ '$http', '$templateCache', '$timeout', '$q', '$window', '$scope', '$compile', '$rootScope', '$state', 'planSamplingService', 'alertService',
		'ASEBIOL_CONSTANTS', 'uiCalendarConfig', 'permissionStatesService', 'uiCalendarConfig', 'clientService', sampleScheduleCtrlFn ]);

function sampleScheduleCtrlFn($http, $templateCache, $timeout, $q, $window, $scope, $compile, $rootScope, $state, planSamplingService, alertService, ASEBIOL_CONSTANTS, uiCalendarConfig,
		permissionStates, uiCalendarConfig, clientService) {
	var vm = this;

	vm.validation = {
			tag : {
				maxlength : 50
			}
		
		};
	
	vm.DTM_FORMAT = ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT;
	vm.pagination = {
		current : 1
	};
	vm.samples = [];
	vm.eventSource = [ [] ];
	vm.limitTo = 20;
	vm.sampleSelected = {
		user : {}
	};
	vm.user = {};
	vm.sampleStates = SAMPLE_STATE.values();
	vm.clientDetail = undefined;
	vm.siteDetail = undefined;
	vm.sampleProfessionalRole = ROLE_TYPE.SAMPLES_PROFESSIONAL.id;
	
	vm.tab = 1;

	vm.loading = false;

	var htmlForm = undefined;
	var htmleNoEditForm = undefined;

	var tipShowing = {
		api : {},
		event : {}
	};

	init();

	/*
	 * se ejecuta eal cargar el controlador
	 */
	function init() {
		var now = moment();

		$http.get("formShedule.html", {
			cache : $templateCache
		}).then(function(html) {
			htmlForm = html.data;
		});

		$http.get("sampleNoEditForm.html", {
			cache : $templateCache
		}).then(function(html) {
			htmleNoEditForm = html.data;
		});

	}

	vm.onPageChange = function(newPageNumber) {
		console.log(newPageNumber);
		console.log($scope);
		$scope.$$childHead.ctrlflt.onPageChange(newPageNumber);
	}
	/*
	 * actualizar usuario o tag
	 */
	vm.sendAction = function() {
		console.log($scope);
		vm.closeAllTips();
		asignSample(vm.sampleSelected);
		tagSample(vm.sampleSelected.tag, vm.sampleSelected);
	}

	/*
	 * cierra tool tip
	 */
	vm.closeAllTips = function() {
		$('div.qtip:visible').qtip('hide');
	}

	/*
	 * Cliek en la listas de muestras
	 */
	vm.onClickList = function(sample) {
		vm.setSampleSelected(sample);
	}

	/*
	 * setSampleSelected
	 */
	vm.setSampleSelected = function(sample) {
		vm.sampleSelected = sample;
		vm.sampleSelected.user = {};
		if (vm.sampleSelected.professionalSampling) {
			var user = {
				email : vm.sampleSelected.professionalSampling.email,
				firstName : vm.sampleSelected.professionalSampling.firstName,
				id : vm.sampleSelected.professionalSampling.id,
				lastName : vm.sampleSelected.professionalSampling.lastName,
				username : vm.sampleSelected.professionalSampling.username
			};
			vm.sampleSelected.user.selected = user;
			vm.sampleSelected.idUserOld = user.id;
		}
	}

	/**
	 * utils
	 */
	vm.findSampleByid = function(id) {
		return findByid(vm.samples, id);
	}

	function findEventByid(id) {
		return findByid(vm.eventSource[0], id);
	}

	function findByid(array, id) {
		return array.find(function(e) {
			return e.id == id;
		});
	}

	/*
	 * Actualiza el profesional de muestreo
	 */
	var loadAsign = false;
	function asignSample(sample) {
		if (!(sample.user && sample.user.selected))
			return;
		var user = sample.user.selected;
		// se cambio el usuario?
		if (user.id === sample.idUserOld)
			return;
		vm.loading = true;
		loadAsign = true;
		var asignModel = {
			idUser : user.id
		};
		planSamplingService.asignSample(sample.planSampling.id, sample.sampling.id, sample.id, asignModel).then(function(response) {
			loadAsign = false;
			vm.loading = loadTag;
			alertService.showSuccess("Muestra asignada satisfactoriamente");
			if (!loadTag)
				vm.updateSample(sample.planSampling.id, sample.sampling.id, sample.id);
		}, function(response) {
			loadAsign = false;
			vm.loading = loadTag;
		});
	}

	/*
	 * Asigna el tag a la muestra
	 */
	var loadTag = false;
	function tagSample(tag, sample) {
		if (!tag)
			return;
		vm.loading = true;
		loadTag = true;
		var tagModel = {
			tag : tag
		};
		planSamplingService.tagSample(sample.planSampling.id, sample.sampling.id, sample.id, tagModel).then(function(response) {
			loadTag = false;
			vm.loading = loadAsign;
			alertService.showSuccess("Etiqueta asignada satisfactoriamente");
			if (!loadAsign)
				vm.updateSample(sample.planSampling.id, sample.sampling.id, sample.id);
		}, function(response) {
			loadTag = false;
			vm.loading = loadAsign;
		});
	}

	/*
	 * Configura los tooltip que se vana mistrar, el que se muestra al mover el
	 * mouse y el formulario de editar
	 */
	var loadClient = false, loadSite = false, loadAResult = false;
	vm.setToolTip = function(element, sample) {
		if (_isNotMobile) {
			element.qtip({
				content : {
					text : getToolTipInfo(sample),
					title : {
						text : 'Muestra #' + sample.idSample
					}
				},
				position : {
					viewport : $("#divMain"),
					target : 'mouse',
					adjust : {
						x : 5,
						y : 5
					},
				// container: $('.scrollerTip')
				},
				hide : {
					event : 'unfocus click mouseleave' // 
				},
				style : 'qtip-dark qtip-shadow'
			});
			element.removeData('qtip')
		}
		var htmlContent = htmlForm;
		if (!permissionStates.canEditSample(sample.state)) {
			htmlContent = htmleNoEditForm;
		}

		var position;
		if ($window.innerWidth < 1024) {
			position = {
				viewport : $('#MyCalendar'),
				// target : 'mouse',
				my : 'center',
				at : 'center',
				effect : false,
				container : $("#MyCalendar"),
				adjust : {
					scroll : false,
					mouse : false
				}
			};
		} else {
			position = {
				viewport : $("#MyCalendar"),
				// target: 'mouse',
				my : 'left center',
				at : 'right center',
				container : $("#MyCalendar"),
				adjust : {
					scroll : false,
					mouse : false
				}
			};
		}

		element.qtip({
			content : {
				text : function(event, api) {
					return qTipLoadData(sample, htmlContent).then(function(content) {
						vm.tab = 1;
						var text;
						text = $compile(content)($scope);
						return text;
					}, function(xhr, status, error) {
						api.set('content.text', status + ': ' + error);
					});
				},
				title : {
					text : "Muestra " + sample.idSample,
					button : true
				}
			},
			position : position,
			show : {
				event : 'click',
				solo : true
			},
			hide : {
				// fixed : true,
				event : 'unfocus' // 
			},
			style : {
				classes : 'qtip-bootstrap qtip-shadow qtip-rounded',
				width : "500px"
			},
			events : {
				hide : function(event, api) {
					vm.clientDetail = undefined;
					vm.siteDetail = undefined;
					vm.analysisResultDetail = undefined;
					tipShowing = {};
				},
				show : function(event, api) {
					tipShowing.api = api;
					tipShowing.event = event;
				}

			}
		});
	}

	function qTipLoadData(sample, htmlContent) {
		return $q(function(resolve, reject) {

			if (!permissionStates.canEditSample(sample.state)) {
				resolve(htmlContent);
			}

			loadClient = false;
			loadSite = false;
			loadAResult = false;

			var idClient = vm.sampleSelected.client.id;
			var idSite = vm.sampleSelected.site.id;
			var idPlanSampling = vm.sampleSelected.planSampling.id;
			var idSampling = vm.sampleSelected.sampling.id;
			var idSample = vm.sampleSelected.id;

			clientService.getClient(idClient).then(function(response) {
				vm.clientDetail = response.getData();
				loadClient = true;
				if (loadSite && loadAResult)
					resolve(htmlContent);
			}, function(response) {
				vm.clientDetail = undefined;
				loadClient = true;
				if (loadSite && loadAResult)
					resolve(htmlContent);
			});

			clientService.getClientSite(idClient, idSite).then(function(response) {
				vm.siteDetail = response.getData();
				loadSite = true;
				if (loadClient && loadAResult)
					resolve(htmlContent);
			}, function(response) {
				vm.siteDetail = undefined;
				loadSite = true;
				if (loadClient && loadAResult)
					resolve(htmlContent);
			});

			planSamplingService.getSampleAnalysisResult(idPlanSampling, idSampling, idSample).then(function(response) {
				vm.analysisResultDetail = response.getData();
				loadAResult = true;
				if (loadClient && loadSite)
					resolve(htmlContent);
			}, function(response) {
				vm.analysisResultDetail = undefined;
				loadAResult = true;
				if (loadClient && loadSite)
					resolve(htmlContent);
			});
		});
	}

	/*
	 * Ir a un dia especifico en el calendario
	 */
	vm.goToDate = function(date) {
		uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('gotoDate', date);
	}

	/*
	 * genera el template del tooltip
	 */
	vm.getToolTipInfo = getToolTipInfo;
	function getToolTipInfo(sample) {
		var html = "";

		if (!sample.sampling)
			return html;
		html += "<div><span><b>Cliente: </b></span>" + sample.client.name + "</div>";

		html += "<div><span><b>Estado: </b></span>" + getConstantNameById(SAMPLE_STATE, sample.state) + "</div>";

		html += "<div><span><b>Producto: </b></span>" + sample.sampling.product.name + "</div>";

		if (sample.tag)
			html += "<div><span><b>Tag: </b></span>" + sample.tag + "</div>";

		if (sample.scheduleDate)
			html += "<div><span><b>Programado: </b></span>" + sample.scheduleDate.calendar() + "</div>";

		if (sample.isAsigned)
			html += "<div><span><b>Asignado a: </b></span>" + sample.professionalSampling.firstName + " " + sample.professionalSampling.lastName + "</div>";

		html += "<div><span><b>sitio: </b></span>" + sample.site.name + "</div>";

		if (sample.site.requireConfirmation)
			html += "<div><span><b>Requiere confirmación</b></span></div>";
		else
			html += "<div><span><b>No requiere confirmación</b></span></div>";

		return html;
	}

	vm.getToolTipInfoById = function(idEvent) {
		var sample = vm.findSampleByid(idEvent)
		return vm.getToolTipInfo(sample);
	}
	/*
	 * Genera un Objedo evento a partir de la muestra
	 */
	vm.sample2Event = function(sample) {
		var eventObject = {
			id : sample.id,
			title : /* '#' + sample.id + " " + */sample.client.name.substring(0, 10),
			start : moment(sample.scheduleDate, vm.DTM_FORMAT),
			allDay : false,
			durationEditable : false,
			className : 'sampleStates ' + getConstantById(SAMPLE_STATE, sample.state).className,
			// textColor : 'black',
			isAsigned : sample.isAsigned,
			requireConfirmation : sample.site.requireConfirmation,
			product : sample.sampling.product.name.substring(0, 10),
			tag : sample.tag,
			editable : permissionStates.canEditSample(sample.state)
		};
		return eventObject;
	}

	/*
	 * Acualiza la muestra
	 */
	vm.updateSample = function(idPlan, idSampling, idSample) {
		planSamplingService.getSampleBasicInfo(idPlan, idSampling, idSample).then(function(response) {
			var sample = response.getData();
			var s = vm.findSampleByid(idSample);

			console.log(s);

			s.className = getConstantById(SAMPLE_STATE, sample.state).className;
			s.state = sample.state;
			s.isAsigned = sample.isAsigned;
			s.professionalSampling = sample.professionalSampling;
			s.Tag = sample.Tag;
			s.scheduleDate = moment(sample.scheduleDate, vm.DTM_FORMAT);

			if (sample.scheduleDate) {
				var event = uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('clientEvents', idSample)[0];
				event.className = 'sampleStates ' + s.className;
				event.isAsigned = s.isAsigned;
				event.editable = permissionStates.canEditSample(s.state);
				uiCalendarConfig.calendars["sampleCalendar"].fullCalendar('updateEvent', event);
			}

			console.log(s);

			s = vm.findSampleByid(idSample);

			console.log(s);

		}, function(response) {
		})
	}

	vm.scheduleSample = function(idPlanSampling, idSampling, idSample, scheduleDate, fnOk, fnRevert) {
		var scheduleModel = {
			scheduleDate : scheduleDate.format($scope.ctrl.DTM_FORMAT)
		};
		$scope.ctrl.loading = true;
		planSamplingService.scheduleSample(idPlanSampling, idSampling, idSample, scheduleModel).then(function(response) {
			$scope.ctrl.loading = false;
			alertService.showSuccess("Muestra reprogramada satisfactoriamente");
			if (fnOk)
				fnOk();
		}, function(response) {
			if (fnRevert)
				fnRevert();
			$scope.ctrl.loading = false;
		});
	}

}